import { getUserInfo } from "../api/usercall";
import { getUserFavorites } from "../api/favoritecall";
import { getRegions } from "../api/location/getRegions";
import { getAgreementTemplates } from "../api/getAgreementTemplates";

/**
 * Warm profile-related caches in the background on app load so the profile
 * tabs (finance, settings, favorites, contract templates) render instantly
 * when opened. The remote backend has cold-start latency; firing these
 * fire-and-forget while the user is still on the home page hides it.
 * Auth-dependent calls no-op when there is no access token.
 */
export function prefetchProfileData() {
    getUserInfo().catch(() => {});
    getUserFavorites().catch(() => {});
    getRegions().catch(() => {});
    getAgreementTemplates().catch(() => {});
}